import { useState } from 'react';
import { Link } from 'react-router-dom';
import { LuArrowRight, LuCircleCheck } from 'react-icons/lu';
import { Badge } from '../../ui/Labels';
import { Button, ButtonLink } from '../../ui/Button';
import { Countdown } from '../../ui/Countdown';
import { useToast } from '../../ui/Toast';
import { useStrings } from '../../tenant/TenantProvider';
import { useCatalog } from '../../stores/catalog';
import { useNow } from '../../hooks/useNow';
import { contestApi } from '../../lib/contestApi';
import { formatDateTime, formatDuration } from '../../lib/format';
import { cx } from '../../ui/cx';

export function ContestPanel({ contest, primary }) {
  const t = useStrings();
  const { show } = useToast();
  const now = useNow(1000);
  const [registering, setRegistering] = useState(false);

  if (!contest) return null;
  const live = contest.state === 'live';
  const remaining = Date.parse(live ? contest.endTime : contest.startTime) - now;

  const register = async () => {
    setRegistering(true);
    const response = await contestApi.register(contest.id);
    setRegistering(false);
    if (response.success) {
      useCatalog.getState().patchContest(contest.id, { registered: true, participants: contest.participants + 1 });
      show(t('contests.registeredToast', { name: contest.name }));
    } else {
      show(response.error, 'error');
    }
  };

  return (
    <section className={cx('panel contest-panel lit', live && 'energy energy--glow')} aria-labelledby="contest-panel-title">
      <div className="panel__header">
        <h2 id="contest-panel-title" className="panel__title">
          {live ? t('problems.contest.live') : t('problems.contest.upcoming')}
        </h2>
        {live ? (
          <Badge tone="success" dot>
            {t('contests.states.live')}
          </Badge>
        ) : (
          contest.registered && (
            <Badge tone="success">
              <LuCircleCheck aria-hidden="true" />
              {t('problems.contest.registered')}
            </Badge>
          )
        )}
      </div>
      <div className="panel__body">
        <Link to={`/contests/${contest.id}`} className="contest-panel__name" viewTransition>
          {contest.name}
        </Link>
        <p className="contest-panel__meta">
          {formatDateTime(contest.startTime)} · {formatDuration(contest.durationMinutes)}
        </p>
        <div className="contest-panel__clock">
          <span className="contest-panel__clock-label">{live ? t('problems.contest.endsInLabel') : t('problems.contest.startsInLabel')}</span>
          <Countdown ms={remaining} size="md" />
        </div>
        <div className="contest-panel__actions">
          {live && contest.registered ? (
            <ButtonLink to={`/contests/${contest.id}/arena`} variant={primary ? 'primary' : 'secondary'} block trail={LuArrowRight}>
              {t('problems.contest.enter')}
            </ButtonLink>
          ) : live ? (
            <ButtonLink to={`/contests/${contest.id}/standings`} block viewTransition>
              {t('contests.standings')}
            </ButtonLink>
          ) : contest.registered ? null : (
            <Button block loading={registering} onClick={register}>
              {t('problems.contest.register')}
            </Button>
          )}
          <Link to="/contests" className="text-link contest-panel__all" viewTransition>
            {t('problems.contest.viewAll')}
          </Link>
        </div>
      </div>
    </section>
  );
}
